import domain from './domain';

// Reset task category groups
export const resetTaskCategoryGroups = domain.createEvent('resetTaskCategoryGroups');